<template>
  <div class="block block-fx-shadow block-rounded">
    <div class="block-header block-header-default border-b ">
        <h3 class="block-title">Эффективность сотрудников</h3>
    </div>
    <div class="table-responsive">
      <table class="table table-borderless table-striped table-hover">
        <thead>
          <tr>
            <th>#</th>
            <th>ФИО</th>
            <th>План</th>
            <th>Платеж</th>
            <th>Эффективность</th>
          </tr>
        </thead>
        <tbody>
          <template v-if="!loadUsers">
            <tr v-for="(user, index) in users" :key="index">
              <td>{{++index}}</td>
              <td>{{user.lastname}} {{user.firstname}} {{user.middlename}}</td>
              <td>{{user.redemption_plans ? (user.redemption_plans[0] ? user.redemption_plans[0].amount: 0) : 0}} {{ $t('app.kzt') }}</td>
              <td>{{user.sum_payments}} {{ $t('app.kzt') }}</td>
              <td>{{ performanceCalculator(user) }} %</td>
            </tr>
          </template>
          <tr v-if="loadUsers">
            <td colspan="8" class="text-center">
              <loader-wave/>
            </td>
          </tr>
        </tbody>
      </table>
    </div>
  </div>
</template>

<script>
export default {
  data() {
    return {
      users: [],
      loadUsers: false,
      redemption_plan: {
        user_id: null,
        amount: 0,
      },
    };
  },
  mounted() {
    this.fetchUsersRating();
  },
  methods: {
    fetchUsersRating() {
      this.loadUsers = true;
      window.axios.get('/admin/stats/users/raiting')
        .then((res) => {
          this.users = res.data.users;
        })
        .catch((err) => {
          this.errorHandler(err);
        })
        .finally(() => {
          this.loadUsers = false;
        });
    },
    performanceCalculator(user) {
      const userRedemptionPlans = user.redemption_plans ? user.redemption_plans[0] : 0;
      const redemptionAmount = userRedemptionPlans ? user.redemption_plans[0].amount : 0;
      const result = ((user.sum_payments * 100) / redemptionAmount).toFixed(2);
      let performance = 0;
      if (isFinite(result)) {
        performance = result;
      }
      return performance;
    },
  },
};
</script>
